import React, { useEffect, useState } from 'react';
import { Checkbox, TagPicker } from 'rsuite';
import '../inputBox.css';

function TagSelectPicker(props) {
  const {
    placeholder,
    label,
    selectStyle,
    msgStyle,
    labelStyle,
    showMSG,
    retuired,
    data,
    onSelect,
    valueKey,
    onSearch,
    labelKey,
    defaultValue,
    style,
    defaultData,
    value,
    container,
    onClean,
    disabled,
    icon_state = '',
    giveSelectAllOption,
  } = props;

  let timeout = '';
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (defaultData && typeof defaultData === 'object') {
      const verifyData = data.find((item) => item[valueKey] == defaultData[valueKey]);
      if (!verifyData) {
        data.unshift(defaultData);
      }
    }
  }, [defaultData]);

  const handleSelectValue = (arr) => {
    let selectedData = [];
    let selectedValues = [];
    let selectedTitle = [];
    data?.map((item) => {
      if (arr?.includes(item[valueKey])) {
        selectedData.push(item);
        selectedValues.push(item[valueKey]);
        selectedTitle.push(item[labelKey]);
      }
    });
    onSelect(selectedValues, selectedTitle, selectedData);
  };
console.log("====DATA==",data)
  const renderMenuItem = (label, item) => {
    console.log('===ITEMS===',item)
    let bulletColor = '';
    if (item?.icon_state==='green') bulletColor = 'green';
    else if (item?.icon_state==='red') bulletColor = 'red';
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        
        <span
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: bulletColor,
            display: 'inline-block'
          }}
        />
      <span>{label}</span>
    </div>
    );
  };

  const handleSelectAllToggle = () => {
    const allValues = data.map((item) => item[valueKey]);
    if (selectAll) {
      handleSelectValue([]);
    } else {
      handleSelectValue(allValues);
    }
    setSelectAll(!selectAll);
  };

  return (
    <div>
      {label && (
        <label className='inputlabel' style={labelStyle}>
          {retuired && <span className='requiredInput'> * </span>} {label}
        </label>
      )}
      <TagPicker
        disabled={disabled || false}
        container={container}
        data={data}
        onClean={() => {
          onClean ? onClean() : onSelect && handleSelectValue([]);
        }}
        placement='autoVerticalStart'
        onChange={handleSelectValue}
        value={value || []}
        // onSelect={handleSelectValue}
        valueKey={valueKey}
        labelKey={labelKey}
        defaultValue={defaultValue}
        onSearch={(str) => {
          if (typeof onSearch === 'function') {
            if (str?.trim()?.length > 2) {
              if (timeout) {
                clearTimeout(timeout);
              }
              timeout = setTimeout(() => {
                onSearch(str);
              }, 300);
            } else {
              onSearch('');
            }
          }
        }}
        style={{ ...style, ...selectStyle }}
        placeholder={placeholder}
        renderMenuItem={renderMenuItem}
        renderMenu={(menu) => (
          <>
            {giveSelectAllOption && data?.length > 0 && (
              <div style={{ padding: '8px 12px', borderBottom: '1px solid #ddd' }}>
                <Checkbox
                  checked={selectAll && value?.length == data?.length}
                  // indeterminate={value?.length > 0 && value.length < data?.length}
                  onChange={handleSelectAllToggle}
                >
                  Select All
                </Checkbox>
              </div>
            )}
            {menu}
          </>
        )}
      />

      {showMSG && (
        <div className='inputMsg' style={msgStyle}>
          {showMSG}
        </div>
      )}
    </div>
  );
}

TagSelectPicker.defaultProps = {
  data: [],
  valueKey: 'id',
  labelKey: 'title',
  style: { width: '100%' },
  msgStyle: { color: 'red' },
  giveSelectAllOption: false,
};

export default TagSelectPicker;
